import React from 'react'
import styled from 'styled-components'

import { ReactComponent as CrossIcon } from 'icons/cross-circle-24.svg'
import { ReactComponent as ExclamationMark } from 'icons/exclamation-mark-16.svg'
import { ReactComponent as Information } from 'icons/information-16.svg'

import {
  Wrapper,
  BannerType,
  CloseButton,
  Text,
  IconWrapper,
} from './Banner.styles'

export interface BannerProps {
  className?: string
  type: BannerType
  dismissible?: boolean
  onDismiss?: (event: React.MouseEvent<HTMLElement>) => void
}

const Banner: React.FC<BannerProps> = props => {
  const { className, children, type, dismissible, onDismiss } = props

  const Icon = type === 'error' ? ExclamationMark : Information

  return (
    <Wrapper
      className={className}
      data-testid={`banner-${type}`}
      role="alert"
      $type={type}>
      <IconWrapper>
        <Icon />
      </IconWrapper>
      <Text>{children}</Text>
      {dismissible && (
        <CloseButton onClick={onDismiss}>
          <span className="sr-only">Close banner</span>
          <CrossIcon aria-hidden />
        </CloseButton>
      )}
    </Wrapper>
  )
}
export default styled(Banner)``
